import BaseScene from '../core/BaseScene.js'
import BaseCamera from '../core/BaseCamera.js'
import { webgl } from '../core/GL.js'

export default class Scene extends BaseScene {

    init() {
        super.init()

        this.camera = new BaseCamera()
        this.camera.base.position.set(0, 0, 3)
        this.camera.base.lookAt(0, 0, 0)
    }


    render() {
        const renderer = webgl.$renderer.instance
        if (!renderer || !this.camera) return
        renderer.render(this.base, this.camera.base)
    }


    resize() {
        if (this.camera) this.camera.resize()
    }

}
